module.exports = __webpack_public_path__ + "img/samorzad.f7400da6.jpg";